import {RootState} from 'redux/store';

export const getZBaseDetailsState = (state: RootState) => state.zBase;
export const getZBaseDetailsRawLogs = (state: RootState) => state.zBase.logs;
export const getZBaseNetworkState = (state: RootState) => state.zBase.data.networkStatus;
